import currencyNavStyle from '../pages/currency/components/Navbar/NavbarCurrency.scss';
import Productmenu from '../pages/currency/components/Navbar/Productmenu/ProductsMenu';
import { Component, Fragment } from 'react';
import { Link, Router } from '../configs/routes';
import styles from '../styles/header.scss';
import { isDescendant } from '../utils';
import base64 from 'base-64';
import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();

/**
 * TODO
 * -  Refactor this component while creating the new component to remove unused
 *    code
 * -  Make staging and localhost also use new login sso
 */

interface Props {
  isUserLoggedIn: any;
  url: any;
  hideHeaderSearch: boolean;
  showHeaderNavLinks?: boolean;
  isMobile?: boolean;
  showNudge: boolean;
  nudgeRequired: boolean;
}

interface State {
  isDropdownOpen: boolean;
  currentPath: string;
  showDropdown: boolean;
  openDropdown: boolean;
  mobileNavVisible: boolean;
  exploremore: boolean;
  productsDropdown: boolean;
  isUserLoggedIn: boolean;
}

class NavbarCurrency extends Component<Props, State> {
  public state: State = {
    isDropdownOpen: false,
    currentPath: '',
    showDropdown: false,
    openDropdown: false,
    mobileNavVisible: false,
    exploremore: false,
    productsDropdown: false,
    isUserLoggedIn: false,
  };

  public componentDidMount() {
    this.changeCurrentPath();
  }

  public changeMobileNav = (visibility: boolean) => {
    this.setState({
      mobileNavVisible: visibility,
    });
    document.body.style.overflow = visibility ? 'hidden' : 'auto';
  };

  public changeCurrentPath = () => {
    if (typeof location !== 'undefined') {
      document.addEventListener('click', this.toggleDropdown);
      if (location.pathname === '/save/login') {
        return this.setState({
          currentPath: location.search,
        });
      }
      this.setState({
        currentPath:
          location.pathname === '/save/login'
            ? location.search
            : `${location.pathname + location.search}`,
      });
    }
  };

  public UNSAFE_componentWillReceiveProps() {
    this.changeCurrentPath();
  }

  public componentWillUnmount() {
    document.removeEventListener('click', this.toggleDropdown);
  }

  public toggleDropdown = (e: any) => {
    e.stopPropagation();
    const { id = '', nodeName = '' } = e.target || {};
    if (
      (id === 'dropdown_trigger' ||
        isDescendant('dropdown_trigger', e.target)) &&
      !isDescendant('navbar-collapse', e.target)
    ) {
      this.setState({ isDropdownOpen: !this.state.isDropdownOpen });
    } else if (nodeName !== 'A') {
      this.setState({
        isDropdownOpen: false,
        showDropdown: false,
        openDropdown: false,
      });
    }
  };

  public showDropdown = (e: any) => {
    e.preventDefault();
    this.setState({ showDropdown: true });
  };
  public hideDropdown = (e: any) => {
    e.preventDefault();
    this.setState({ showDropdown: false });
  };
  public openDropdown = (a: any) => {
    a.preventDefault();
    this.setState({ openDropdown: true });
  };
  public closeDropdown = (a: any) => {
    a.preventDefault();
    this.setState({ openDropdown: false });
  };

  // public handleClick = (e: any) => {
  //   document.body.style.overflow = 'auto';
  //   this.changeMobileNav(false);
  //   const { link, scroll } = e.target.dataset;
  //   if (link) {
  //     Router.pushRoute(`${link}`);
  //   } else if (scroll) {
  //     Router.pushRoute(`/save#${scroll}`);
  //   }
  // };

  private handleLogout = async () => {
    try {
      if (typeof googleyolo !== 'undefined') {
        await googleyolo.disableAutoSignIn();
      }
    } catch (err) {}
    Router.push('/save/logout');
  };

  private renderLogo = () => {
    return (
      <Link href={{ pathname: '/save' }}>
        <a id="header-logo" className="lil-flex lil-items-center">
          <img
            className="lil-mr-6"
            width="153"
            title="Home: ClearTax"
            alt="Clear"
            src="https://assets1.cleartax-cdn.com/cleartax/images/1627895302_clearfromctblack.png"
          />
        </a>
      </Link>
    );
  };

  public render() {
    const { currentPath, openDropdown, mobileNavVisible } = this.state;
    let loginHref;
    let returnPath;
    switch (publicRuntimeConfig.env) {
      case 'development':
        loginHref = `/save/login?refer=${currentPath}`;
        break;
      case 'staging':
        loginHref = `/save/login?refer=${currentPath}`;
        break;
      case 'production':
        returnPath = base64.encode(`${currentPath}`);
        loginHref = `https://accounts.cleartax.in/?product=save&return_path=${returnPath}`;
        break;
      default:
        loginHref = `/save/login?refer=${currentPath}`;
    }
    const { isUserLoggedIn, isMobile, showNudge, nudgeRequired } = this.props;

    return (
      <Fragment>
        {mobileNavVisible ? (
          <div className={`full-width full-height, ${styles['overlay']}`}>
            <div className={styles['nav-pane']}>
              <div className={styles['search-section']}>
                <span
                  className={`
                    lil-cursor-pointer
                    lil-text-font-500
                    lil-text-s-24
                    ${styles['cross-button']}
                  `}
                  onClick={() => this.changeMobileNav(false)}
                >
                  {' '}
                  &#215;
                </span>
              </div>
              <ul className="lil-px-6 lil-pt-6">
                <li className="lil-flex lil-items-center lil-pt-4">
                  <a
                    className=" lil-text-base lil-font-medium  md:lil-mx-1 lil-nav-text"
                    href="https://cleartax.in/s/income-tax?ref=currency-header-it-desktop"
                    target="_blank"
                  >
                    Explore Income Tax
                  </a>
                </li>
                <li className="lil-flex lil-items-center lil-pt-4">
                  <a
                    className=" lil-text-base lil-font-bold lil-text-blue-350 md:lil-mx-1 lil-nav-text"
                    href="https://cleartax.in/s/income-tax?ref=currency-header-it-desktop"
                    target="_blank"
                  >
                    File ITR
                  </a>
                </li>

                <li className="lil-flex lil-items-center lil-pt-4">
                  <div className="lil-w-full lil-my-3">
                    <div
                      className="lil-flex lil-items-center"
                      onClick={() =>
                        this.setState({ exploremore: !this.state.exploremore })
                      }
                    >
                      <p className="lil-w-11/12 lil-text-s-20 lil-font-bold">
                        Explore More
                      </p>
                      <span className="lil-inline-block lil-caret lil-ml-1 md:lil-ml-0 lil-caret-down"></span>
                    </div>
                    {this.state.exploremore ? (
                      <div className="lil-block lil-bg-grey-150 lil-py-2 lil-mt-4 lil-rounded-lg">
                        <div className=" lil-p-4 lil-font-medium lil-text-s-20 lil-font-medium ">
                          <a
                            target="_blank"
                            className="hover:lil-text-blue-350"
                            href="https://cleartax.in/s/business?ref=content-header-business-desktop"
                          >
                            Business
                          </a>
                        </div>
                        <div className=" lil-p-4 lil-font-medium lil-text-s-20 lil-font-medium ">
                          <a
                            target="_blank"
                            className="hover:lil-text-blue-350"
                            href="https://cleartax.in/s/mutual-funds?ref=content-header-investments-desktop"
                          >
                            Mutual Funds
                          </a>
                        </div>
                        <div className=" lil-p-4 lil-font-medium lil-text-s-20 lil-font-medium ">
                          <a
                            target="_blank"
                            className="hover:lil-text-blue-350"
                            href="https://cleartax.in/s/about-us?ref=content-header-it-desktop"
                          >
                            About Us
                          </a>
                        </div>
                        <div className=" lil-p-4 lil-font-medium lil-text-s-20 lil-font-medium ">
                          <a
                            target="_blank"
                            className="hover:lil-text-blue-350"
                            href="https://docs.cleartax.in/cleartax-learn?ref=content-header-it-desktop"
                          >
                            ClearLearn
                          </a>
                        </div>
                        <div className=" lil-p-4 lil-font-medium lil-text-s-20 lil-font-medium ">
                          <a
                            target="_blank"
                            className="hover:lil-text-blue-350"
                            href="https://news.cleartax.in?ref=content-header-it-desktop"
                          >
                            ClearChronicles
                          </a>
                        </div>
                        <div className=" lil-p-4 lil-font-medium lil-text-s-20 lil-font-medium ">
                          <a
                            target="_blank"
                            className="hover:lil-text-blue-350"
                            href="https://cleartax.in/Meta/Contact?ref=content-header-it-desktop"
                          >
                            Support
                          </a>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </li>
                <li className="lil-flex lil-items-center lil-pt-4">
                  <div className="lil-w-full lil-my-3">
                    <div
                      className="lil-flex lil-items-center"
                      onClick={() =>
                        this.setState({
                          productsDropdown: !this.state.productsDropdown,
                        })
                      }
                    >
                      <p className="lil-w-11/12 lil-text-s-20 lil-font-bold">
                        Products
                      </p>
                      <span className="lil-inline-block lil-caret lil-ml-1 md:lil-ml-0 lil-caret-down"></span>
                    </div>
                    {this.state.productsDropdown ? <Productmenu /> : null}
                  </div>
                </li>

                {!isUserLoggedIn ? (
                  <li key="login-logout">
                    <div className="lil-flex lil-mt-4">
                      <div className="lil-flex lil-flex-col lil-pt-4">
                        <Link route={loginHref}>
                          <a className="lil-mt-6 lil-btn lil-btn-blue">
                            Login/Signup
                          </a>
                        </Link>
                      </div>
                    </div>
                  </li>
                ) : null}
              </ul>
              {isUserLoggedIn ? (
                <div className="lil-mt-4 lil-pl-4">
                  <div className="lil-flex lil-flex-wrap lil-py-8 lil-mb-8">
                    <div
                      className="lil-flex lil-w-full"
                      id="nav-my-account-container"
                    >
                      <div className="lil-w-full lil-my-4">
                        <details className="lil-w-full lil-accordian">
                          <summary className="lil-cursor-pointer">
                            <div className="lil-flex lil-items-center">
                              <p className="lil-w-11/12 lil-text-s-20 lil-ml-4">
                                My Account
                              </p>
                              <div className="lil-w-1/12 lil-accordian-caret lil-order-3 lil-ml-auto"></div>
                            </div>
                          </summary>
                          <div className="lil-block lil-bg-grey-150 lil-py-2 lil-mt-4 lil-rounded-lg">
                            <div className="lil-p-4 lil-text-font-500 lil-text-s-20 lil-font-medium">
                              <a
                                className="hover:lil-text-blue-350"
                                href="https://gst.cleartax.in/n?ref=static-login-dropdown"
                                referrerPolicy="no-referrer-when-downgrade"
                              >
                                My GST
                              </a>
                            </div>

                            <div className="lil-p-4 lil-text-font-500 lil-text-s-20 lil-font-medium">
                              <a
                                className="hover:lil-text-blue-350"
                                href="https://taxcloudindia.com/Entity"
                                referrerPolicy="no-referrer-when-downgrade"
                              >
                                My Taxcloud
                              </a>
                            </div>

                            <div className="lil-p-4 lil-text-font-500 lil-text-s-20 lil-font-medium">
                              <a
                                className="hover:lil-text-blue-350"
                                href="https://cleartds.com/deductors"
                                referrerPolicy="no-referrer-when-downgrade"
                              >
                                My TDS
                              </a>
                            </div>

                            <div className="lil-p-4 lil-text-font-500 lil-text-s-20 lil-font-medium">
                              <a
                                className="hover:lil-text-blue-350"
                                href="https://ewb.cleartax.in/"
                                referrerPolicy="no-referrer-when-downgrade"
                              >
                                My e-Way Bill
                              </a>
                            </div>

                            <div className="lil-p-4 lil-text-font-500 lil-text-s-20 lil-font-medium">
                              <a
                                className="hover:lil-text-blue-350"
                                href="https://cleartax.in/launchpad?source=gst"
                              >
                                All Products
                              </a>
                            </div>
                          </div>
                        </details>
                      </div>
                    </div>
                  </div>
                  <div
                    id="nav-logout"
                    className="lil-px-4 lil-py-2 lil-text-font-500 lil-text-s-20 lil-font-medium"
                  >
                    <a
                      className="lil-text-font-500 lil-text-s-20 lil-font-semibold lil-cursor-pointer hover:lil-text-blue-350"
                      onClick={this.handleLogout}
                    >
                      Logout
                    </a>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
        <nav
          className={`lil-nav ${
            showNudge && isMobile && nudgeRequired ? styles.top60 : ''
          }`}
          id="app-header"
        >
          <div className="lil-container lil-h-full lil-justify-between lil-w-full lil-items-center lil-flex sm:lil-px-4">
            <div className="lil-flex lil-items-center lil-h-full sm:lil-w-1/2">
              {this.renderLogo()}
              <div
                onMouseEnter={() =>
                  this.setState({
                    productsDropdown: !this.state.productsDropdown,
                  })
                }
                onMouseLeave={() =>
                  this.setState({
                    productsDropdown: !this.state.productsDropdown,
                  })
                }
                className="lil-relative lil-mr-8 lil-flex lil-items-center lil-h-full sm:lil-hidden lil-dropdown lil-mx-6 md:lil-mx-1 nav-dropdown"
              >
                <div className="lil-text-base lil-font-medium lil-nav-text lil-cursor-pointer lil-w-full">
                  Products
                  <span className="lil-inline-block lil-caret lil-ml-1 md:lil-ml-0 lil-caret-down"></span>
                </div>

                {this.state.productsDropdown ? <Productmenu /> : null}
              </div>
            </div>

            <div className="lil-flex lil-justify-end lil-items-center lil-h-full sm:lil-w-1/2">
              <div className="sm:lil-hidden md:lil-hidden lil-mx-auto">
                <a
                  className="lil-text-base lil-font-medium lil-mx-6 md:lil-mx-1 lil-nav-text"
                  href="https://cleartax.in/s/income-tax?ref=currency-header-it-desktop"
                  target="_blank"
                >
                  Explore Income Tax
                </a>
              </div>
              <div
                className="sm:lil-hidden lil-relative lil-mr-10 lil-flex lil-items-center lil-h-full lil-dropdown lil-mx-6 md:lil-mx-1 nav-dropdown"
                onMouseLeave={() =>
                  this.setState({ exploremore: !this.state.exploremore })
                }
                onMouseEnter={() =>
                  this.setState({ exploremore: !this.state.exploremore })
                }
              >
                <div className="lil-text-base lil-font-medium lil-nav-text lil-cursor-pointer">
                  Explore more
                  <span className="lil-inline-block lil-caret lil-ml-1 md:lil-ml-0 lil-caret-down"></span>
                </div>
                {this.state.exploremore ? (
                  <div
                    className={`lil-flex lil-flex-col lil-absolute lil-rounded-xl lil-shadow-lg ${currencyNavStyle['exploremore']}`}
                  >
                    <a
                      target="_blank"
                      className="lil-mt-4 lil-font-medium lil-text-s-18 hover:lil-text-blue-350"
                      href="https://cleartax.in/s/gst-law-goods-and-services-tax?ref=content-header-gst-desktop"
                    >
                      GST
                    </a>
                    <a
                      target="_blank"
                      className="lil-mt-4 lil-font-medium lil-text-s-18 hover:lil-text-blue-350"
                      href="https://cleartax.in/s/e-invoicing-enterprise-software?ref=content-header-it-desktop"
                    >
                      E-Invoicing
                    </a>
                    <a
                      target="_blank"
                      className="lil-mt-4 lil-font-medium lil-text-s-18 hover:lil-text-blue-350"
                      href="https://cleartax.in/s/business?ref=content-header-business-desktop"
                    >
                      Business
                    </a>
                    <a
                      target="_blank"
                      className="lil-mt-4 lil-font-medium lil-text-s-18 hover:lil-text-blue-350"
                      href="https://cleartax.in/s/mutual-funds?ref=content-header-investments-desktop"
                    >
                      Mutual Funds
                    </a>
                    <a
                      target="_blank"
                      className="lil-mt-4 lil-font-medium lil-text-s-18 hover:lil-text-blue-350"
                      href="https://cleartax.in/s/about-us?ref=content-header-it-desktop"
                    >
                      About Us
                    </a>
                    <a
                      target="_blank"
                      className="lil-mt-4 lil-font-medium lil-text-s-18 hover:lil-text-blue-350"
                      href="https://docs.cleartax.in/cleartax-learn?ref=content-header-it-desktop"
                      referrerPolicy="no-referrer-when-downgrade"
                    >
                      ClearLearn
                    </a>
                    <a
                      target="_blank"
                      className="lil-mt-4 lil-font-medium lil-text-s-18 hover:lil-text-blue-350"
                      href="https://news.cleartax.in?ref=content-header-it-desktop"
                      referrerPolicy="no-referrer-when-downgrade"
                    >
                      ClearChronicles
                    </a>
                    <a
                      target="_blank"
                      className="lil-mt-4 lil-font-medium lil-text-s-18 hover:lil-text-blue-350"
                      href="https://cleartax.in/Meta/Contact?ref=content-header-it-desktop"
                    >
                      Support
                    </a>
                  </div>
                ) : null}
              </div>
              <div className="sm:lil-hidden lil-mx-auto">
                <a
                  className="lil-mr-8 lil-text-base lil-font-bold lil-text-blue-350 md:lil-mx-1 lil-nav-text"
                  href="https://cleartax.in/s/income-tax?ref=currency-header-it-desktop"
                  target="_blank"
                >
                  File ITR
                </a>
              </div>

              <div className="lil-hidden sm:lil-flex lil-items-center">
                <div className="mobile-only--display small-2 columns">
                  <button onClick={() => this.changeMobileNav(true)}>
                    <div className="lil-toggle" id="mobile-header-toggle">
                      <div className="lil-toggle-bar"></div>
                      <div className="lil-toggle-bar"></div>
                      <div className="lil-toggle-bar lil-toggle-bar-half"></div>
                    </div>
                  </button>
                </div>
              </div>
              {isUserLoggedIn ? (
                <div className="lil-h-full sm:lil-hidden">
                  <div
                    className="lil-flex lil-items-center lil-h-full lil-dropdown lil-mx-6 md:lil-mx-1"
                    onMouseEnter={this.openDropdown}
                    onMouseLeave={this.closeDropdown}
                  >
                    <div className="lil-text-base lil-font-bold lil-nav-text lil-cursor-pointer">
                      My Account
                      <span className="lil-inline-block lil-caret lil-caret-down lil-ml-1 md:lil-ml-0"></span>
                    </div>

                    {openDropdown && (
                      <div
                        className="lil-shadow-sm lil-rounded-lg lil-fixed lil-bg-white"
                        style={{ width: '12rem', top: '74px' }}
                        id="navbar-collapse"
                        ref={dropdown => (this.dropdown = dropdown)}
                      >
                        <div className="lil-p-4 lil-text-font-500 lil-text-s-20 lil-font-medium">
                          <a
                            className="hover:lil-text-blue-350"
                            href="https://gst.cleartax.in/n?ref=static-login-dropdown"
                            referrerPolicy="no-referrer-when-downgrade"
                          >
                            My GST
                          </a>
                        </div>
                        <div className="lil-p-4 lil-text-font-500 lil-text-s-20 lil-font-medium">
                          <a
                            className="hover:lil-text-blue-350"
                            href="https://taxcloudindia.com/Entity"
                            referrerPolicy="no-referrer-when-downgrade"
                          >
                            My Taxcloud
                          </a>
                        </div>
                        <div className="lil-p-4 lil-text-font-500 lil-text-s-20 lil-font-medium">
                          <a
                            className="hover:lil-text-blue-350"
                            href="https://cleartds.com/deductors"
                            referrerPolicy="no-referrer-when-downgrade"
                          >
                            My TDS
                          </a>
                        </div>
                        <div className="lil-p-4 lil-text-font-500 lil-text-s-20 lil-font-medium">
                          <a
                            className="hover:lil-text-blue-350"
                            href="https://ewb.cleartax.in/"
                            referrerPolicy="no-referrer-when-downgrade"
                          >
                            My e-Way Bill
                          </a>
                        </div>
                        <div className="lil-p-4 lil-text-font-500 lil-text-s-20 lil-font-medium">
                          <a
                            className="hover:lil-text-blue-350"
                            href="https://cleartax.in/launchpad?source=gst"
                          >
                            All Products
                          </a>
                        </div>
                        <div
                          id="nav-logout"
                          className="lil-px-4 lil-py-2 lil-text-font-500 lil-text-s-20 lil-font-medium"
                        >
                          <a
                            className="lil-text-s-20 lil-font-medium lil-cursor-pointer hover:lil-text-blue-350"
                            onClick={this.handleLogout}
                          >
                            Logout
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div className="lil-flex sm:lil-hidden">
                  <div className="lil-flex sm:lil-hidden">
                    <Link route={loginHref}>
                      <a className="lil-btn lil-btn-blue">Login/Signup</a>
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>
        </nav>
      </Fragment>
    );
  }
}
export default NavbarCurrency;



// WEBPACK FOOTER //
// ./components/NavbarCurrency.tsx